import { FormProvider, useForm } from 'react-hook-form'
import { ComplaintFlowInputs, ComplaintFlowProps } from './types.ts'
import { Card, StepIndicator } from '@boltenergy-be/design-system'
import Complaint from './steps/Complaint.tsx'
import Overview from './steps/Overview.tsx'
import Confirmation from './steps/Confirmation.tsx'
import { COMPLAINT_STEPS, ComplaintStep } from 'pages/app/support/complaint-form/constants.ts'
import { useState } from 'react'
import styles from './ComplaintForm.module.scss'
import EditLayout from 'layouts/edit-layout/EditLayout.tsx'
import { useTranslation } from 'react-i18next'

const ActiveComplaintStep = (props: ComplaintFlowProps) => {
  switch (props.currentStep) {
    case 'overview': {
      return <Overview {...props} />
    }

    case 'confirmation': {
      return <Confirmation />
    }

    default: {
      return <Complaint {...props} />
    }
  }
}

const ComplaintForm = () => {
  // i18n
  const { t } = useTranslation('support', { keyPrefix: 'complaintForm' })

  // Local state
  const [currentStep, setCurrentStep] = useState<ComplaintStep>('complaint')

  // React hook form
  const hookForm = useForm<ComplaintFlowInputs>({
    mode: 'onChange',
    defaultValues: {
      subject: '',
      description: ''
    }
  })

  // Constants
  const activeStepIndex = COMPLAINT_STEPS.findIndex((step) => step === currentStep)
  const stepsForIndicator = COMPLAINT_STEPS.filter((step) => step !== 'confirmation')

  return (
    <EditLayout
      title={
        <div className={styles['indicator-group']}>
          <strong className="h6">{t(($) => $.navigation.title)}</strong>
          {currentStep !== 'confirmation' && (
            <>
              <small>
                {t(($) => $.navigation.stepCounter, {
                  current: activeStepIndex + 1,
                  total: stepsForIndicator.length
                })}
              </small>
              <StepIndicator activeIndex={activeStepIndex} totalSteps={stepsForIndicator.length} classnames={{ list: styles.indicator }} />
            </>
          )}
        </div>
      }
    >
      <FormProvider {...hookForm}>
        <Card className={styles['complaint-card']}>
          <ActiveComplaintStep {...{ currentStep, setCurrentStep }} />
        </Card>
      </FormProvider>
    </EditLayout>
  )
}

export default ComplaintForm
